import React, { useState } from "react";
import { AddLink } from "@mui/icons-material";
import { Button, Stack, ToggleButton } from "@mui/material";
import { useCurrentEditor } from "@tiptap/react";
import LegalbirdIoModal from "../../../Modal/LegalbirdIoModal";
import { FormContainer, TextFieldElement, useForm } from "react-hook-form-mui";
import { requiredFieldDefaultFieldBased } from "../../../../services/reactHookFormValidationRules";

export default function InsertLink() {
  const { editor } = useCurrentEditor();
  const [modalOpen, setModalOpen] = useState(false);

  const defaultValues = {
    label: "",
    url: "",
  };

  const formContext = useForm<{ label: string; url: string }>({
    mode: "onBlur",
    defaultValues,
  });

  if (!editor) {
    return null;
  }

  const handleConfirm = (values: typeof defaultValues) => {
    editor.chain().focus().deleteSelection().insertContent(`<a href="${values.url}">${values.label}</a>`).run();
    setModalOpen(false);
  };

  return (
    <ToggleButton
      value={""}
      onClick={() => {
        setModalOpen(true);
      }}
    >
      <AddLink />
      <LegalbirdIoModal
        title={"Link hinzufügen"}
        open={modalOpen}
        handleClose={(event: any) => {
          event.stopPropagation();
          setModalOpen(false);
        }}
      >
        <FormContainer formContext={formContext}>
          <Stack spacing={2} sx={{
            marginTop: "1rem"
          }}>
            <TextFieldElement name={"url"} rules={requiredFieldDefaultFieldBased} label={"Link"} />
            <TextFieldElement name={"label"} rules={requiredFieldDefaultFieldBased} label={"Label"} />
            <Button onClick={formContext.handleSubmit(handleConfirm)} variant={"contained"}>Einfügen</Button>
          </Stack>
        </FormContainer>
      </LegalbirdIoModal>
    </ToggleButton>
  );
}
